export default [
  {
    path: '/admin/departments',
    name: 'department',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/department')
  }
]
